import React, { useCallback, useState, useEffect, useContext } from "react";
import axios from 'axios';
import fileDownload from "js-file-download";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import InfoModalContent from '../Layout/InfoModalContent';

import { SiteContext } from "../../context/SiteContext";
import { UserContext } from "../../context/UserContext";

const ShowBatchAssignation = ({
    id
}) => {
    const { env, csrfToken } = useContext(SiteContext);
    const { user } = useContext(UserContext);

    const [status, setStatus] = useState("pending");
    const [showDownloadReport, setShowDownloadReport] = useState(false);

    const fetchAssignationStatus = useCallback(
        () => {
            axios
                .get(env.webApiBaseUrl + "/batchAssignations/" + encodeURIComponent(id) + "/status", {
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        "X-CSRF-Token": csrfToken,
                        Authorization: "Bearer " + user.token,
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    setStatus(response.data);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                });
        },
        [csrfToken, env.webApiBaseUrl, id, user.token]
    );

    const downloadReport = useCallback(
        () => {
            const url = env.webApiBaseUrl + "/batchAssignations/" + encodeURIComponent(id) + "/download";
            axios
                .get(url, {
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        "X-CSRF-Token": csrfToken,
                        Authorization: "Bearer " + user.token,
                    },
                    withCredentials: true,
                    responseType: 'blob',
                })
                .then((response) => {
                    const fileContent = response.data;

                    const fecha = new Date();
                    const fechaLocalISO = fecha.getFullYear() +
                        "-" + String(fecha.getMonth() + 1).padStart(2, "0") +
                        "-" + String(fecha.getDate()).padStart(2, "0") +
                        "T" + String(fecha.getHours()).padStart(2, "0") +
                        "_" + String(fecha.getMinutes()).padStart(2, "0") +
                        "_" + String(fecha.getSeconds()).padStart(2, "0");
                    const filename = `picking-masivo-${id}-${fechaLocalISO}.csv`;

                    fileDownload(fileContent, filename, "text/csv", "\uFEFF");
                })
                .catch((error) => {
                    console.error(error);
                    setShowDownloadReport(true);
                })
                .finally(() => {
                });
        },
        [csrfToken, env.webApiBaseUrl, id, user.token],
    );

    useEffect(() => {
        const fetchDetailsOnFinish = (status) => {
            if (!["pending", "processing"].includes(status)) {
                downloadReport();
            }
        }

        fetchDetailsOnFinish(status);
    }, [downloadReport, status]);

    useEffect(() => {
        if (["done", "failed"].includes(status)) return;

        const intervalId = setInterval(() => {
            fetchAssignationStatus();
        }, 2000);

        return () => clearInterval(intervalId);
    }, [status, fetchAssignationStatus]);

    return (
        <Container>
            {["done", "failed"].includes(status)
            ? <div className="text-center w-50 m-auto">
                <InfoModalContent
                    type={status !== "failed" ? "success" : "error"}
                    msg="Se terminó de procesar el picking masivo."
                />
            </div>
            : <div className="text-center w-50 m-auto">
                <InfoModalContent
                    type="loading"
                    msg="Asignando ubicaciones..."
                />
            </div>
            }

            {showDownloadReport
            ? <div className="text-center w-50 m-auto">
                <br />
                <Button
                    onClick={downloadReport}
                >
                    Descargar archivo con asignaciones
                </Button>
            </div>
            : null
            }
        </Container>
    );
};

export default ShowBatchAssignation;
